import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const Pencil1 = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23 5.889L18.111 1L2.746 16.365L1 23L7.635 21.254L23 5.889Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M14.619 4.492L19.508 9.381"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M3.444 15.667L8.333 20.556"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>,
  'Pencil1'
);
